module.exports = __webpack_public_path__ + "img/pvc-naljepnice.a8f318e1.jpg";